import { render, staticRenderFns } from "./ConsultationSheet.vue?vue&type=template&id=113b0496&"
import script from "./ConsultationSheet.vue?vue&type=script&lang=js&"
export * from "./ConsultationSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports